import React from 'react';
import { Tooltip } from 'reactstrap';

// Basic setup of checkmark switch. If need to handle anything will need to add it.

class ToggleSwitch extends React.Component {
    constructor(props) {
        super(props);
        this.toggleToolTip = this.toggleToolTip.bind(this);
        this.state = {
            tooltipOpen: false,
            invalidInput: false
        };
    }

    toggleToolTip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    onChange(checked) {
        this.props.onChange(checked);
    }

    render() {

        const { name, id, autoFocus, disabled, placeholder, icon, value, required, type, className,
            inputErrorMsg, tooltipID, tooltipMsg, isInvalid } = this.props;
        let { checked } = this.props;
        if (!checked) {
            checked = false;
        }
        var dynamicClass = className ? className : '';
        var invalid = this.state.invalidInput && isInvalid;

        return (
            <div className={"switch-group" + (invalid ? " input-invalid" : "")}>
                <label>
                    <div className="switch-label">{icon && <span className={icon} />}{placeholder}</div>
                    <div className="switch">

                            <input type={type ? type : "checkbox"}
                                value={value}
                                className={dynamicClass}
                                required={required}
                                name={name}
                                id={id}
                                disabled={disabled}
                                autoFocus={autoFocus}
                                checked={checked}
                                onChange={(e) => this.onChange(!checked)}
                            />

                        <span className="slider round" />
                    </div>
                </label>
                {(tooltipID && tooltipMsg) && <div className="input-icon-append ">
                    <span className="icon-info" id={tooltipID} />
                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleToolTip}>
                        {tooltipMsg}
                    </Tooltip>
                </div>}
                {inputErrorMsg && <div className="input-error-msg">{inputErrorMsg}</div>}
            </div>);
    }
}
export default ToggleSwitch;
